import { render, staticRenderFns } from "./StatAction.vue?vue&type=template&id=74b4ca34&scoped=true&"
import script from "./StatAction.vue?vue&type=script&lang=js&"
export * from "./StatAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b4ca34",
  null
  
)

export default component.exports